import * as Types from "./mutation-types";
import {
  getDictionary,
  getDuesList,
  getBranchs,
  getZhiCheng,
  getDivisionData,
  memberInvoice
} from "@/api/dictionary.js";
import { securityCheck } from "@/api/login.js";
import { setSessionStore } from "@/utils/sessionStorage";
import CryptoJS from 'crypto-js';
const actions = {
  getDictionaryList({ commit, state }) {
    if (!state.dictionaryList.length) {
      getDictionary().then(res => {
        if (res.success) {
          commit(Types.SETDICTIONARY, res.result);
          
        }
      });
    }
  },
  getMemberTypeList({ commit, state }) {
    // if (!state.memberTypeList.length) {
      getDuesList().then(res => {
        if (res.success) {
          commit(Types.SETMEMBERTYPE, res.result);
        }
      });
    // }
  },
  getInvoiceList({ commit, state }) {
    // if (!state.memberTypeList.length) {
      let memberId=sessionStorage.getItem('memberId')
      return memberInvoice({memberId:memberId}).then(res => {
        if (res.success) {
          const invoiceList = Array.isArray(res.result) ? res.result : [];
          commit("setInvoiceList", invoiceList);
          return invoiceList;
        }
        return [];
      });
    // }
  },
  getBranchsList({ commit, state }) {
    if (!state.branchsList.length) {
      getBranchs().then(res => {
        if (res.success) {
          commit(Types.SETBRANCHS, res.result);
        }
      });
    }
  },
  getZhiChengList({ commit, state }) {
    if (!state.zhichengList.length) {
      getZhiCheng().then(res => {
        commit(Types.SETZHICHENG, res.result);
      });
    }
  },
  getCityList({ commit, state }) {
    if (!state.cityList.length) {
      getDivisionData({
        level: "1"
      }).then(res => {
        commit(Types.SETCITY, res.result);
      });
    }
  },
  securityCheck({ commit }, userInfo) {
    const {
      username,
      password,
      grant_type,
      scope,
      client_id,
      client_secret,
      mobile,
      code,
      device,
      inviterId
    } = userInfo;

    return new Promise((resolve, reject) => {
      // const SECRET_KEY = CryptoJS.enc.Utf8.parse("5684825541395751");
      // const SECRET_IV = CryptoJS.enc.Utf8.parse("8319849165191473");
      // // 密码加密
      // let srcs = CryptoJS.enc.Utf8.parse(password);
      // let encrypted = CryptoJS.AES.encrypt(srcs, SECRET_KEY, {
      //   iv: SECRET_IV,
      //   mode: CryptoJS.mode.CBC,
      //   padding: CryptoJS.pad.ZeroPadding
      // })
      // let password1 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
      // // 用户名加密
      // let srcsName = CryptoJS.enc.Utf8.parse(username);
      // let encryptedName = CryptoJS.AES.encrypt(srcsName, SECRET_KEY, {
      //   iv: SECRET_IV,
      //   mode: CryptoJS.mode.CBC,
      //   padding: CryptoJS.pad.ZeroPadding
      // })
      // let username1 = CryptoJS.enc.Base64.stringify(encryptedName.ciphertext);

      // // 手机号
      // let srcsMobile = CryptoJS.enc.Utf8.parse(mobile);
      // let encryptedMobile = CryptoJS.AES.encrypt(srcsMobile, SECRET_KEY, {
      //   iv: SECRET_IV,
      //   mode: CryptoJS.mode.CBC,
      //   padding: CryptoJS.pad.ZeroPadding
      // })
      // let mobile1 = CryptoJS.enc.Base64.stringify(encryptedMobile.ciphertext);

      securityCheck({
        username: username,
        password: password,
        grant_type:grant_type,
        scope,
        client_id,
        client_secret,
        mobile: mobile,
        code:code,
        device,
        inviterId,
      })
          .then(res => {
            setSessionStore("access_token", res.access_token);
            setSessionStore("refresh_token", res.refresh_token);

            commit(Types.SETTOKEN, res.access_token);
            commit(Types.SETREFRESHTOKEN, res.refresh_token);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
    });
  },
  
  getGroupMemberType({
                       commit,
                       state
                     }) {
    if (state.memberTypeList.length) {
      return
    }

    getGroupDues().then(res => {
      if (res.success) {
        commit(Types.SETMEMBERTYPE, res.result)
      }
    });
  },
  getPersonMemberType({
                        commit,
                        state
                      }) {
    if (state.memberTypeList.length) {
      return
    }

    getDuesList().then(res => {
      if (res.success) {
        commit(Types.SETMEMBERTYPE, res.result)
      }
    });
  },

};

export default actions;
